import PrivacyNoticeLink from './PrivacyNoticeLink';

function OptInDone() {
  return (
    <div className="thank-you-container">
      <div className="thank-you-icon">&#10003;</div>
      <h1>All done</h1>
      <p>You're set up. We'll confirm on WhatsApp once alerts start.</p>
      <PrivacyNoticeLink />
    </div>
  );
}

export default OptInDone;
